import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shadcn_components/ui/select';
import React from 'react';

interface SelectPerPageProps {
  options?: number[];
  value: number;
  onChange: (value: number) => void;
}

const SelectPerPage: React.FC<SelectPerPageProps> = ({
  options = [10, 20, 30, 40, 50],
  value,
  onChange,
}) => {
  return (
    <Select
      // containerProps={{
      //   className: 'max-w-48 [&&]:h-8',
      // }}
      value={String(value)}
      onValueChange={e => {
        onChange(Number(e));
      }}>
      <SelectTrigger className="max-w-48">
        <SelectValue placeholder="Trang" />
      </SelectTrigger>
      <SelectContent>
        {(options).map(pageSize => (
          <SelectItem className="text-sm" key={pageSize} value={String(pageSize)}>
            {pageSize} kết quả / trang
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SelectPerPage;
